import { NgModule } from '@angular/core'
import { CoreCommonModule } from '../../../@core/common.module'
import { LoaderComponent } from './loader/loader.component'
import { BtnLoaderComponent } from './btn-loader/btn-loader.component'
import { CheckVisibleFunctionalDirective } from '../directives/check-visible-functional.directive'
import { SendPushModalComponent } from './send-push-modal/send-push-modal.component'
import { NgSelectModule } from '@ng-select/ng-select'
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap'

@NgModule({
    declarations: [
        LoaderComponent,
        BtnLoaderComponent,
        CheckVisibleFunctionalDirective,
        SendPushModalComponent,
    ],
    imports: [
        CoreCommonModule,
        NgSelectModule,
        NgbModalModule,
    ],
    exports: [
        LoaderComponent,
        BtnLoaderComponent,
        CheckVisibleFunctionalDirective,
        SendPushModalComponent,
    ],
    providers: [],
})
export class SharedComponentsModule { }
